import React from 'react';
import { Provider } from 'react-redux';
import { reduxBatch } from '@manaflair/redux-batch';
import PropTypes from 'prop-types';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import CommonDataListEventsReducer from '../CommonDataListEvents/reducers/commonDataListEventsReducers';
import SpecialsWidgetContainer from './containers/SpecialsWidgetContainer';

import './styles/specialswidget.scss';

class SpecialsWidget extends React.Component {
    static propTypes = {
        source: PropTypes.string,
        isWidget: PropTypes.bool,
        isFavouriteSport: PropTypes.bool,
        sportSlug: PropTypes.string,
    }

    static defaultProps = {
        source: '',
        isWidget: true,
        isFavouriteSport: false,
        sportSlug: '',
    }

    constructor(props) {
        super(props);

        this.store = createStore(
            CommonDataListEventsReducer,
            {},
            compose(
                applyMiddleware(thunk),
                reduxBatch
            )
        );
    }

    render() {
        const { source, isWidget, isFavouriteSport, sportSlug } = this.props;

        return (
            <Provider store={this.store}>
                <SpecialsWidgetContainer
                    source={source}
                    sportSlug={sportSlug}
                    isWidget={isWidget}
                    isFavouriteSport={isFavouriteSport}
                />
            </Provider>
        );
    }
}

export default SpecialsWidget;
